import forge from "node-forge";

export const getTransactionStatusName = (transactionStatus) => {
    switch (transactionStatus){
        case "EKYC_DONE":{
            return(
                <>
                    <div className={`span-lable-grey`}>در انتظار تکمیل اطلاعات</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "INITIAL": {
            return(
                <>
                    <div className={`span-lable-grey`}>در انتظار پرداخت</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "PAID" : {
            return(
                <>
                    <div className={`span-lable-grey`}>در انتظار تکمیل اطلاعات</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "REVOKE" : {
            return(
                <>
                    <div className={`span-lable-grey`}>گواهی ایطال شده</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "CANCEL" : {
            return <div className={`span-lable-red`}>انصراف از صدور گواهی</div>;
        }
        case "REJECTED" : {
            return(
                <>
                    <div className={`span-lable-red`}>در انتظار اصلاح اطلاعات</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "CHECKING_COMPANY_INFO" : {
            return <div>
                    <div className={`span-lable-org`}>در انتظار بررسی اطلاعات</div>
                    <div  style={{"fontSize": "0.8rem"}}>نتیجه به شما پیامک خواهد شد.</div>
                </div>;
        }
        case "COMPANY_INFORMATION_COMPLETED" : {
            return(
                <>
                    <div className={`span-lable-grey`}>در انتظار تکمیل اطلاعات</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "USER_INFORMATION_COMPLETED" : {
            return(
                <>
                    <div className={`span-lable-grey`}>در انتظار تکمیل اطلاعات</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "SENT_CERT_ISSUED" : {
            return(
                <>
                    <div className={`span-lable-grey`}>گواهی در حال صدور</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        case "CERT_ISSUED" : {
            return(
                <>
                    <div className={`span-lable-green`}>گواهی صادر شده است</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );
        }
        default:
            return(
                <>
                    <div className={`span-lable-grey`}>در انتظار تکمیل اطلاعات</div>
                    <button className={`btn bg-dark-green me-2`} style={{"padding" : "2% 6%"}}>
                        <img src={require('../../image/nextIcon.png')} />
                    </button>
                </>
            );  //zahra
    }

}

export const getTransactionStatusPointer = (transactionStatus) => {
    switch (transactionStatus){
        case "EKYC_DONE":{
            return 'pointer';
        }
        case "INITIAL": {
            return 'pointer';
        }
        case "REVOKE": {
            return '';
        }
        case "PAID" : {
            return 'pointer';
        }
        case "CANCEL" : {
            return '';
        }
        case "REJECTED" : {
            return 'pointer';
        }
        case "CHECKING_COMPANY_INFO" : {
            return '';
        }
        case "COMPANY_INFORMATION_COMPLETED" : {
            return 'pointer';
        }
        case "USER_INFORMATION_COMPLETED" : {
            return 'pointer';
        }
        case "SENT_CERT_ISSUED" : {
            return 'pointer';
        }
        case "CERT_ISSUED" : {
            return 'pointer';
        }
        default:
            return '';
    }

}

export const getTransactionStatusNameTable = (transactionStatus) => {
    switch (transactionStatus){
        case "EKYC_DONE":{
            return(
                <>
                    <div className={`span-lable-org span-lable2`}>در انتظار تکمیل اطلاعات</div>
                </>
            );
        }
        case "INITIAL": {
            return(
                <>
                    <div className={`span-lable-grey span-lable2`}>در انتظار پرداخت</div>
                </>
            );
        }
        case "REVOKE" : {
            return(
                <>
                    <div className={`span-lable-red span-lable2`}>گواهی ابطال شده </div>
                </>
            );
        }
        case "PAID" : {
            return(
                <>
                    <div className={`span-lable-org span-lable2`}>در انتظار تکمیل اطلاعات</div>
                </>
            );
        }
        case "CANCEL" : {
            return <div className={`span-lable-red span-lable2`}>انصراف از صدور گواهی</div>;
        }
        case "PAID_CANCEL" : {
            return <div className={`span-lable-yellow span-lable2`}>تسویه شده</div>;
        }
        case "REJECTED" : {
            return(
                <>
                    <div className={`span-lable-red span-lable2`}>در انتظار اصلاح اطلاعات</div>
                </>
            );
        }
        case "CHECKING_COMPANY_INFO" : {
            return <div className={`span-lable-org span-lable2`}>در انتظار بررسی اطلاعات</div>;
        }
        case "COMPANY_INFORMATION_COMPLETED" : {
            return(
                <>
                    <div className={`span-lable-org span-lable2`}>در انتظار تکمیل اطلاعات</div>
                </>
            );
        }
        case "USER_INFORMATION_COMPLETED" : {
            return(
                <>
                    <div className={`span-lable-org span-lable2`}>در انتظار احراز هویت </div>
                </>
            );
        }
        case "SENT_CERT_ISSUED" : {
            return(
                <>
                    <div className={`span-lable-org span-lable2`}>  کاربر در انتظار صدور گواهی است</div>
                </>
            );
        }
        case "CERT_ISSUED" : {
            return(
                <>
                    <div className={`span-lable-green span-lable2`}>گواهی صادر شده است</div>
                </>
            );
        }
        default:
            return(
                <>
                    <div className={`span-lable-org span-lable2`}>در انتظار تکمیل اطلاعات</div>
                </>
            );
    }

}

export function changeDateToFarsi(DateUTC, checkExpireValid) {

    const IranTime = new Date(DateUTC);

    IranTime.setMinutes(
        IranTime.getMinutes() +
        IranTime.getTimezoneOffset() +
        210, // Iran's time zone offset is UTC+3:30
    );

    if(checkExpireValid) {
        const now = new Date();
    }

    const hours = String(IranTime.getHours()).padStart(2, "0");
    const minutes = String(IranTime.getMinutes()).padStart(2, "0");

    return ` ${hours}:${minutes} \u00A0\u00A0 ${IranTime.toLocaleDateString('fa-IR')}`
}


export const getStatusForDetailReq = (status, certificate, certType) => {

    if(certificate) {

        const certPem = '-----BEGIN CERTIFICATE-----' + certificate + '-----END CERTIFICATE-----'
        let cert = forge.pki.certificateFromPem(certPem)
        const expirationUTC = cert.validity.notAfter;
        const expireTime = changeDateToFarsi(expirationUTC, true)
        return <span style={{color: "#33ba39"}}>صادر شده و دارای گواهی معتبر تا تاریخ {expireTime} می‌باشد.</span>

    }else{

        switch (status){
            case "EKYC_DONE":{
                return(
                    certType === "Personality" ?
                    <span style={{color: "#898989"}}> در انتظار دریافت کلیدها توسط مشتری</span>
                    :
                    <span style={{color: "#898989"}}> در انتظار دریافت کلیدها توسط نماینده سازمان</span>
                );
            }
            case "INITIAL": {
                return(
                    certType === "Personality" ?
                        <span style={{color: "#898989"}}>در انتظار پرداخت توسط مشتری</span>
                    :
                        <span style={{color: "#898989"}}>در انتظار پرداخت توسط نماینده سازمان</span>
                );
            }
            case "REVOKE": {
                return(
                    certType === "Personality" ?
                        <span style={{color: "#de3f3f"}}>گواهی ابطال شده</span>
                        :
                        <span style={{color: "#de3f3f"}}>گواهی ابطال شده</span>
                );
            }
            case "PAID" : {
                return(
                    certType === "Personality" ?
                        <span style={{color: "#898989"}}>در انتظار تکمیل اطلاعات فردی توسط مشتری</span>
                    :
                        <span style={{color: "#898989"}}>در انتظار تکمیل اطلاعات سازمان یا شرکت توسط نماینده</span>
                );
            }
            case "CANCEL" : {
                return <span style={{color: "#de3f3f"}}>انصراف از صدور گواهی</span>;
            }
            case "REJECTED" : {
                return(
                    <span style={{color: "#898989"}}>در انتظار اصلاح اطلاعات سازمان یا شرکت توسط نماینده</span>
                );
            }
            case "CHECKING_COMPANY_INFO" : {
                return <span style={{color: "#898989"}}>در انتظار بررسی اطلاعات شرکت یا سازمان توسط کارشناس</span>;
            }
            case "COMPANY_INFORMATION_COMPLETED" : {
                return(
                    <span style={{color: "#898989"}}>در انتظار تکمیل اطلاعات فردی توسط نماینده</span>
                );
            }
            case "USER_INFORMATION_COMPLETED" : {
                return(
                    certType === "Personality" ?
                        <span style={{color: "#898989"}}>در انتظار احراز هویت تصویری </span>
                    :
                        <span style={{color: "#898989"}}>در انتظار احراز هویت تصویری توسط نماینده</span>
                );
            }
            case "SENT_CERT_ISSUED" : {
                return(
                    <span style={{color: "#898989"}}>در انتظار صدور گواهی</span>
                );
            }
            case "CERT_ISSUED" : {
                return(
                    <span style={{color: "#33ba39"}}>گواهی صادر شده است</span>
                );
            }
            default:
                return(
                    <span style={{color: "#898989"}}>در انتظار تکمیل اطلاعات</span>
                );
        }

    }
}